/*! Lazy init for predictive search & cart drawer to improve INP */
(function(){
  function loadScriptOnce(src, cb){
    if(document.querySelector('script[data-lazy-src="'+src+'"]')){ cb && cb(); return; }
    var s=document.createElement('script'); s.src=src; s.defer=true; s.dataset.lazySrc=src;
    s.onload=function(){ cb && cb(); }; document.head.appendChild(s);
  }
  // Predictive search: load on first focus/typing in search input
  document.addEventListener('focusin', function(e){
    var input = e.target.closest('input[type="search"], predictive-search input');
    if(!input) return;
    var url = '{{ "predictive-search.aio.min.js" | asset_url }}';
    loadScriptOnce(url);
  }, true);

  // Cart drawer: load on first tap on cart icon; prevent navigation once
  document.addEventListener('click', function(e){
    var link = e.target.closest('#cart-icon-bubble');
    if(!link) return;
    // If cart drawer class is already defined, do nothing special
    if (customElements.get('cart-drawer')) return;
    e.preventDefault();
    var url = '{{ "cart-drawer.aio.min.js" | asset_url }}';
    loadScriptOnce(url, function(){
      // Re-dispatch the click to trigger the drawer open logic
      setTimeout(function(){ link.click(); }, 0);
    });
  }, true);
})();